:host {
  display: inline-block;
  vertical-align: middle;
}
